<template>
  <div v-if="criteresRecherche" class="tableWithPerPageSelection">
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="relanceSelectionne"
            ></selecteur-action>
          </div>
          <form @submit.prevent="recherche()"
                class="column is-5 pdr-0 pdl-0">
              <b-input :placeholder="$t('general.button.search')" type="search" icon="magnify"
                       v-model="criteresRecherche.auto">
              </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('listeCommandes.actions.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right columns">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permissionsRelances.exporter"
            :query="exportExcelQuery"/>
        </div>
          <parametrage-table
            :reference-table="referenceTable"
            @endLoadParamtre="startArrayRendering = true">
          </parametrage-table>
      </div>
    </div>
    <v-server-table
      url=""
      :columns="columns"
      :options="options"
      :ref="referenceTable"
      @loaded="finLoading"
      @loading="debutLoading"
      v-if="startArrayRendering && mountedLoadingEnd">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)" />
      </template>
      <div slot="selected" class="has-text-centered" slot-scope="props">
        <b-checkbox v-model="props.row.selected"
                    :value="props.row"
                    @input="selectionRelances()"></b-checkbox>
      </div>
      <div slot="relanceLibelle" slot-scope="props" class="is-pulled-left">
        <router-link-blank
          :to="{ name: 'c.bodac.factures', params: { id: props.row.factureId } }"
          :message="props.row.relanceLibelle"/>
      </div>
      <div slot="commandeCode" slot-scope="props" class="is-pulled-left">
        <router-link-blank
          v-if="props.row.commandeId"
          :to="{ name: 'c.bodac.commandes', params: { id: props.row.commandeId } }"
          :message="props.row.commandeCode"/>
      </div>
      <div slot="payeurNomCommercial" slot-scope="props">
        <section class="is-flex is-justify-content-space-between">
          <router-link-blank
            :to="{ name: 'c.bodac.clients/contacts-client', params: { id: props.row.payeurId } }"
            :message="props.row.payeurNomCommercial"/>
            <niveau-blocage-icone
              v-if="props.row.payeurBlocageLevel"
              :niveau="props.row.payeurBlocageLevel"
              :description="props.row.payeurDescriptionBlocage"
            />
        </section>
        {{ props.row.payeurTelephone }}
      </div>
      <div slot="annonceurs" slot-scope="props" class="is-pulled-left">
        {{ props.row.annonceurs.join(', ') }}
      </div>
      <div slot="commercial" slot-scope="props" class="is-pulled-left">
        {{ getNomPrenomCommercial(props.row.factureCommercialId)}}
      </div>
      <div slot="dateMouvement" slot-scope="props" class="is-pulled-left">
        {{ props.row.dateMouvement | formatDate }}
      </div>
      <div slot="factureDate" slot-scope="props" class="is-pulled-left">
        {{ props.row.factureDate | formatDate }}
      </div>
      <div slot="dateDerniereRelance" slot-scope="props" class="is-pulled-left">
        {{ props.row.dateDerniereRelance | formatDate }}
      </div>
      <div slot="montantTtc" slot-scope="props" class="is-pulled-right">
        {{ props.row.montantTtc | formatDevise}}
      </div>
      <div slot="retard" slot-scope="props" class="is-pulled-left">
        {{ props.row.retard }} {{ $t('relance.jours') }}
      </div>
      <div slot="resteALettrer" slot-scope="props" class="is-pulled-right">
        {{ props.row.resteALettrer | formatDevise}}
      </div>
      <div slot="commentaireRelance" slot-scope="props">
        <commentaireListInput
          :id="props.row.factureId"
          v-model="props.row.commentaireRelance"
          :maj="majCom">
        </commentaireListInput>
      </div>
      <div slot="agence" slot-scope="props">
        {{ getAgenceLibelle(props.row.factureAgenceId) }}
      </div>
      <div slot="action" slot-scope="props">
        <b-tooltip
          :label="$t('relance.impossibleDeCreerLaRelance')"
          :active="props.row.nePasRelancer"
          position="is-left">
          <button
            class="button is-primary is-fullwidth"
            :class="{'button-access-no-permission': !checkPermissions(permissionsRelances.maj)
              || props.row.nePasRelancer }"
            @click="checkPermissions(permissionsRelances.maj)
              ? openPopUpRelance([props.row]) : showPopUp()"
            :disabled="props.row.nePasRelancer">
            {{ props.row.actionLibelle }}
          </button>
        </b-tooltip>
      </div>
    </v-server-table>
    <div class="componentBrief" v-show="showFiltre === true">
        <filtre-retard ref="filtreRetard"
            @toggleFiltre="setShowFiltre"
            v-model="criteresRecherche"
            :isFromClient="isFromClient"
            @recherche="makeRechercheFilter()"/>
    </div>
    <b-modal v-model="popUpPreventionRelance" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="$t('relance.popUpPreventionRelance.title')"
        :cancel="$t('general.button.return')"
        :validate="$t('relance.popUpPreventionRelance.generer')"
        :questions="questions"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        @no="popUpPreventionRelance = false"
        @validateQuestions="relanceEnMasse">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import inProgress from '@/services/general/inProgress';
import messageErreur from '@/services/general/messageErreur';
import {
  TEXTS, RESULTS_PER_PAGE, SORT_ICON, NO_PER_PAGE_VALUE,
} from '@/configuration/clientTableConf';
import { RELANCE } from '@/configuration/permissionsBodacConf';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import { commenterRelance } from '@/api/facture/index';
import filtreRetard from '@/components/relances/filtreRetard';
import formatIsoDate from '@/services/general/formatIsoDate';
import { columnsSplice } from '@/services/general/columns';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import selecteurAction from '@/components/general/selecteurAction';
import { ACTION_RELANCER, GET_LAST_PAY_LOAD } from '@/configuration/relances/relancesConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { REFERENCE_TABLE_RETARD_PAIEMENT } from '@/configuration/general/referenceTableConf';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import parametrageTable from '@/components/general/parametrageTable';
import popUpPrevention from '@/components/general/popUpPrevention';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import commentaireListInput from '@/components/general/input/commentaireListInput/commentaireListInput';
import { grouperEcheancesSelectionnes } from '@/services/relances/relanceManager';
import initialUsers from '@/services/general/filters/filterinitUsers';
import { COMMERCIAL, DIRECTEUR_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import {
  LIMITE_AU_PAIEMENT_COMPTANT,
  TOTAL,
} from '@/configuration/tiers/levelBlocage';
import levelString from '@/services/tiers/levelToString';
import { SET_RETOUR_DETAIL } from '@/store/modules/relance-mutation-type';
import NiveauBlocageIcone from '@/components/general/NiveauBlocageIcone';

const permissions = createNamespacedHelpers('permissions');
const societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');
const Relance = createNamespacedHelpers('relance');

export default {
  name: 'l_listeDesRetards',
  props: {
    isFromClient: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      permissionsRelances: RELANCE,
      allRelanceSelected: false,
      relanceSelectionne: false,
      showFiltre: false,
      unsubscribeValue: null,
      startArrayRendering: false,
      mountedLoadingEnd: false,
      actions: [
        { action: ACTION_RELANCER, translation: 'relance.relancer' },
      ],
      referenceTable: REFERENCE_TABLE_RETARD_PAIEMENT,
      popUpPreventionRelance: false,
      questions: [],
      mouvementClientsSelectionnes: [],
      messagesErreurPopUp: [],
      errorPopUp: false,
      resultPerPage: RESULTS_PER_PAGE,
      listeCommercial: [],
      getLastPayLoad: false,
    };
  },
  components: {
    routerLinkBlank,
    filtreRetard,
    commentaireListInput,
    selecteurAction,
    TableItemsInView,
    parametrageTable,
    popUpPrevention,
    exportExcelButton,
    NiveauBlocageIcone,
  },
  beforeDestroy() {
    if (this.lockMenu) this.setLockMenu(false);
    this.unsubscribeValue();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.getLastPayLoad = this.$route.params.getLastPayLoad === GET_LAST_PAY_LOAD;
      this.setRetourDetail(null);
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
        PARAMETRES_INTERNE_KEYS.modulePresse.key]);
      await this.loadParametres([PARAMETRES_KEYS.utilisateur.key]);
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.updateAgenceAndRecherche, this.goFirstPage);
      this.setInformationPage(this.$t('pageGescom.retard.liste'));
      await updateCritereWithParametreInterne(this.criteresRecherche);
      this.criteresRecherche.agenceIdFacture = this.agencesSelectionnees
        .map((agence) => agence.agenceId);
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
      loadParametres: 'loadParametres',
    }),
    ...Relance.mapMutations({
      setRetourDetail: SET_RETOUR_DETAIL,
    }),
    actionsLoadEchRetard(data) {
      return this.$store.dispatch(`${this.storeName}/loadEchRetard`, data);
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreRetard.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    getAgenceLibelle(agenceId) {
      const agenceActiveFind = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === agenceId;
      });
      if (agenceActiveFind) return agenceActiveFind.libelleAgence;
      return '';
    },
    updateAgenceAndRecherche() {
      this.criteresRecherche.agenceIdFacture = this.agencesSelectionnees
        .map((agence) => agence.agenceId);
      this.recherche();
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    validationRelanceMasse() {
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
      const findMvtRelancable = this.mouvementClientsSelectionnes.filter(mvt => mvt.nePasRelancer);
      if (findMvtRelancable.length === 0) return true;
      this.errorPopUp = true;
      const codes = findMvtRelancable.map(el => el.factureCode).join(', ');
      this.messagesErreurPopUp = [{
        message: findMvtRelancable.length > 1 ? 'addNewRelance.facturesNonRelancable' : 'addNewRelance.factureNonRelancable',
        parametres: { codes, code: codes },
      }];
      return false;
    },
    relanceEnMasse(questions) {
      if (!this.validationRelanceMasse()) return;
      let isRegrouperParPayeur = false;
      if (questions && questions
        .find((q) => { return q.key === 0; })) {
        isRegrouperParPayeur = questions.find((q) => {
          return q.key === 0;
        }).value;
      }
      const listeEcheanceARelancer = this.mouvementClientsSelectionnes.map((echeancePaiement) => {
        return {
          ...echeancePaiement,
          numRelance: echeancePaiement.numRelance + 1,
        };
      });

      this.setRetourDetail({
        name: this.$route.name,
        params: {
          ...this.$route.params,
          getLastPayLoad: GET_LAST_PAY_LOAD,
        },
      });

      this.$router.push({
        name: 'm.bodac.relance',
        params: {
          echeancesPaiement: listeEcheanceARelancer,
          isRegrouperParPayeur: isRegrouperParPayeur,
          isFromClient: this.isFromClient,
        },
      });
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    selectAll() {
      this.allRelanceSelected = !this.allRelanceSelected;
      this.items.forEach((el) => {
        el.selected = this.allRelanceSelected;
      });
      this.relanceSelectionne = this.allRelanceSelected;
    },
    selectionRelances() {
      this.relanceSelectionne = this.items.filter((el) => {
        return el.selected;
      }).length > 0;
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    handleAction(action) {
      if (action === ACTION_RELANCER) {
        if (this.checkPermissions(this.permissionsRelances.maj)) {
          this.openPopUpRelance(this.items
            .filter((el) => { return el.selected; }));
        } else this.showPopUp();
      }
    },
    openPopUpRelance(echeancesSelectionnes) {
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
      const groupes = grouperEcheancesSelectionnes(echeancesSelectionnes);
      if (Object.values(groupes).some(echs => echs.length > 1)) {
        this.questions = [{
          key: 0,
          value: true,
          message: 'relance.popUpPreventionRelance.regrouperParPayeur',
        }];
      }
      this.mouvementClientsSelectionnes = echeancesSelectionnes;
      this.popUpPreventionRelance = true;
    },
    async reinitialiser() {
      await this.$refs.filtreRetard.initializeFiltre();
      await this.$refs.filtreRetard.viderCritere();
      this.$refs.filtreRetard.appliquerCritere();
      this.showFiltre = false;
    },
    getBlocageInfo(level) {
      switch (level) {
        case LIMITE_AU_PAIEMENT_COMPTANT:
          return {
            libelle: levelString(this.$i18n, level),
            typeIcon: 'is-warning',
          };
        case TOTAL:
          return {
            libelle: levelString(this.$i18n, level),
            typeIcon: 'is-danger',
          };
        default:
          return null;
      }
    },
    changeAllCommentWithSameFactId(factureId, commentaire) {
      if (this.items.length > 0) {
        this.items.forEach((el) => {
          if (el.factureId === factureId) {
            el.commentaireRelance = commentaire;
          }
        },
        );
      }
    },
    async majCom(id, commentaire) {
      await commenterRelance({
        id: id,
        commentaire: commentaire,
      });
      this.changeAllCommentWithSameFactId(id, commentaire);
    },
    getNomPrenomCommercial(commercialId) {
      if (!commercialId) return '';
      const commercial = this.listeCommercial.find(c => c.id === commercialId);
      if (commercial) {
        return `${commercial.nom ?? ''} ${commercial.prenom ?? ''}`.trim();
      }
      return '';
    },
    getCustomOptions() {
      if (this.getLastPayLoad) {
        return {
          perPage: this.lastDataFromLoad.MaxResultCount,
          initialPage: (this.lastDataFromLoad.SkipCount / this.lastDataFromLoad.MaxResultCount) + 1,
          orderBy: {
            ascending: this.lastDataFromLoad.Sorting.split(' ')[1] === 'ASC',
            column: this.lastDataFromLoad.Sorting.split(' ')[0],
          },
        };
      }
      return {
        perPage: this.resultPerPage,
        initialPage: 1,
        orderBy: {
          ascending: true,
          column: null,
        },
      };
    },
  },
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
      agencesSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
      parametres: 'parametre',
    }),
    storeName() {
      return this.isFromClient ? 'retardPaiementClient' : 'retardPaiement';
    },
    lastDataFromLoad() {
      return this.$store.getters[`${this.storeName}/lastDataFromLoad`];
    },
    criteresRecherche: {
      get() {
        return this.$store.getters[`${this.storeName}/criteresRecherche`];
      },
      set(value) {
        this.$store.commit(`${this.storeName}/SET_CRITERE`, value);
      },
    },
    items() {
      return this.$store.getters[`${this.storeName}/items`];
    },
    totalCount() {
      return this.$store.getters[`${this.storeName}/totalCount`];
    },
    lastPayload() {
      return this.$store.getters[`${this.storeName}/lastPayload`];
    },
    nombreCritere() {
      const banCritereKey = ['auto', 'dates', 'datesFacture', 'datesLastRelance', 'nePasRelancer',
        'commercialId', 'agenceIdFacture', 'blocageReglement', 'noDateLastRelance', 'societeId'];
      let nombreCritere = calculNombreCritere(this.criteresRecherche, banCritereKey);
      if (this.criteresRecherche.dates) {
        nombreCritere += this.criteresRecherche.dates.dateDebut ? 1 : 0;
        nombreCritere += this.criteresRecherche.dates.dateFin ? 1 : 0;
      }
      if (this.criteresRecherche.datesFacture) {
        nombreCritere += this.criteresRecherche.datesFacture.dateDebut ? 1 : 0;
        nombreCritere += this.criteresRecherche.datesFacture.dateFin ? 1 : 0;
      }
      if (this.criteresRecherche.datesLastRelance) {
        nombreCritere += this.criteresRecherche.datesLastRelance.dateDebut ? 1 : 0;
        nombreCritere += this.criteresRecherche.datesLastRelance.dateFin ? 1 : 0;
      }
      if (this.criteresRecherche.commercialId && this.criteresRecherche.commercialId.length > 0) {
        nombreCritere += 1;
      }
      if (this.criteresRecherche.agenceIdFacture.length > 0
        && this.societeActive.agences.length !== 1) nombreCritere += 1;
      nombreCritere += this.criteresRecherche.blocageReglement != null ? 1 : 0;
      nombreCritere += this.criteresRecherche.noDateLastRelance != null ? 1 : 0;
      nombreCritere += this.criteresRecherche.nePasRelancer != null ? 1 : 0;
      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
    columns() {
      const columns = ['selected', 'relanceLibelle', 'commandeCode', 'payeurNomCommercial', 'payeurCompteComptable', 'annonceurs', 'commercial', 'factureDate', 'dateMouvement', 'dateDerniereRelance', 'retard', 'montantTtc', 'resteALettrer', 'commentaireRelance', 'agence', 'action'];
      if (this.societeActive.agences.length === 1) {
        columnsSplice(columns, 'agence');
      }
      return columns;
    },
    iconSelectTotal() {
      if (this.allRelanceSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          relanceLibelle: this.$i18n.t('relance.nFacture'),
          commandeCode: this.$i18n.t('relance.nCommande'),
          annonceurs: this.$i18n.t('relance.annonceurs'),
          payeurNomCommercial: this.$i18n.t('relance.payeur'),
          payeurCompteComptable: this.$i18n.t('relance.compteComptable'),
          factureDate: this.$i18n.t('relance.dateFacture'),
          dateMouvement: this.$i18n.t('relance.datePrev'),
          montantTtc: this.$i18n.t('relance.montantTtc'),
          resteALettrer: this.$i18n.t('relance.restantDu'),
          agence: this.$i18n.t('relance.agence'),
          action: '',
          retard: this.$i18n.t('relance.retard'),
          dateDerniereRelance: this.$i18n.t('relance.dateLastRelance'),
          commentaireRelance: this.$i18n.t('relance.commentaireRelance'),
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        texts: TEXTS,
        ...this.getCustomOptions(),
        requestFunction: (async (data) => {
          if (this.getLastPayLoad) {
            data.query = this.lastDataFromLoad.Query;
          }
          if (this.criteresRecherche.agenceIdFacture.length === 0) {
            this.criteresRecherche.agenceIdFacture = this.agencesSelectionnees
              .map((agence) => agence.agenceId);
          }
          if (!data.query) data.query = cloneDeep(this.criteresRecherche);
          if (data.query.dates && data.query.dates.dateDebut) {
            data.query.dates.dateDebut = formatIsoDate(data.query.dates.dateDebut);
          }
          if (data.query.dates && data.query.dates.dateFin) {
            data.query.dates.dateFin = formatIsoDate(data.query.dates.dateFin);
          }
          if (data.query.payeurs.length > 0) {
            data.query.payeurs = data.query.payeurs.map((payeur) => {
              return payeur.id;
            });
          }
          if (this.modulePresseActive && data.query.produits.length > 0) {
            data.query.produitsIds = data.query.produits.map((produit) => {
              return produit.id;
            });
            delete data.query.produits;
          }
          data.query.datesFacture.dateDebut = formatIsoDate(data.query.datesFacture.dateDebut);
          data.query.datesFacture.dateFin = formatIsoDate(data.query.datesFacture.dateFin);
          data.query.datesLastRelance.dateDebut = formatIsoDate(data.query
            .datesLastRelance.dateDebut);
          data.query.datesLastRelance.dateFin = formatIsoDate(data.query.datesLastRelance.dateFin);
          data.query.societeId = this.societeActiveId;
          const users = this.parametres(PARAMETRES_KEYS.utilisateur)
            .filter(user => user.actif);
          this.listeCommercial = initialUsers(users, [DIRECTEUR_COMMERCIAL, COMMERCIAL]);
          let returnValue = await this.actionsLoadEchRetard(data);
          if (this.getLastPayLoad && this.items.length === 0 && data.page > 1) {
            this.$refs[this.referenceTable].setPage(data.page - 1);
            returnValue = await this.actionsLoadEchRetard(data);
          }
          if (this.getLastPayLoad) {
            const composantPagination = this.$refs[this.referenceTable].$children[0].$children
              .find(child => child.constructor.extendOptions.name === 'TableItemsInView');
            composantPagination.value = this.lastDataFromLoad.MaxResultCount;
            this.getLastPayLoad = false;
          }
          return returnValue;
        }),
        responseAdapter: (() => {
          return {
            data: this.items,
            count: this.totalCount,
          };
        }),
        sortable: ['relanceLibelle', 'commandeCode', 'annonceurs', 'dateMouvement', 'montantTtc', 'resteALettrer',
          'payeurNomCommercial', 'payeurCompteComptable', 'factureDate', 'dateDerniereRelance', 'retard'],
        columnsClasses: {
          selected: 'colonneSelected',
          commentaire: 'colonneWidth250px',
        },
      };
    },
    filtrerParUtilisateur() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key);
    },
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    exportExcelQuery() {
      return {
        typeDonnee: 'retardspaiement',
        typeExport: null,
        filtres: this.lastDataFromLoad,
      };
    },
  },
};
</script>

<style scoped>

</style>
